module.exports = __webpack_public_path__ + "static/media/refresh.07b49eab.gif";